function initProjectSliders() {
    document.querySelectorAll('.filterslider__slider').forEach(slider => {
        const max = Math.round(Math.ceil(slider.getAttribute('data-max')/1000) * 1000);
        const inputMinValue = slider.parentElement.querySelector('.filterslider__input--min');
        const inputMaxValue = slider.parentElement.querySelector('.filterslider__input--max');

        if (inputMinValue && inputMaxValue) {
            if (slider.noUiSlider) slider.noUiSlider.destroy();
            noUiSlider.create(slider, {
                start: [
                    Math.max(Math.min(inputMinValue.value, max), 0),
                    Math.min(inputMaxValue.value, max)
                ],
                connect: true,
                step: 5000,
                range: {
                    'min': 0,
                    'max': max
                }
            });
            slider.noUiSlider.on('update', function (values) {
                const minValue = Math.round(values[0]);
                const maxValue = Math.round(values[1]);
                slider.parentElement.querySelector('.filterslider__value').innerHTML =
                    new Intl.NumberFormat("nl-NL", {
                        style: "currency",
                        currency: "EUR",
                        maximumSignificantDigits: 20
                    }).format(minValue)
                    + ' - '
                    + new Intl.NumberFormat("nl-NL", {
                        style: "currency",
                        currency: "EUR",
                        maximumSignificantDigits: 20
                    }).format(maxValue);

                if (minValue != inputMinValue.value || maxValue != inputMaxValue.value) {
                    inputMinValue.value = minValue;
                    inputMaxValue.value = maxValue;
                    inputMinValue.dispatchEvent(new Event('input'));
                    inputMaxValue.dispatchEvent(new Event('input'));
                }
            });
        }
    });
}

document.addEventListener("livewire:init", () => {
    Livewire.on('updatedProjects', () => {
        setTimeout(() => initProjectSliders(), 350);
    });
});
